// extracted by mini-css-extract-plugin
module.exports = {"root":"index-root-W2G_x"};